import React from "react";
import WhyUsImg from "../img/WhyUs.png"; // replace with your image path
import { FaCheckCircle } from "react-icons/fa";
import "../css/style.css";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
const WhyUs = () => {
  return (
    <section className="why-choose-section">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Column - Image */}
            <div className="col-lg-6">
            <h2 className="why-title">Why Choose NeatNest?</h2>
            <p className="why-description">
              We provide professional, reliable, and affordable home cleaning services. Our trained staff ensures your home stays sparkling clean and hygienic.
            </p>

            <ul className="why-list">
              <li><FaCheckCircle className="icon" /> Experienced & Trusted Staff</li>
              <li><FaCheckCircle className="icon" /> Eco-Friendly Cleaning Solutions</li>
              <li><FaCheckCircle className="icon" /> 100% Satisfaction Guarantee</li>
            </ul>

              <Link to="/projects" className="btn btn-primary mt-3 d-inline-flex align-items-center gap-2">Explore Projects
                            <FaArrowRight />
                         </Link>
                         
          </div>
          <div className="col-lg-6 mb-4 mt-4 mb-lg-0">
            <img
              src={WhyUsImg}
              alt="Why Choose Us"
              className="img-fluid rounded shadow"
            />
          </div>

          {/* Right Column - Content */}
        

        </div>
      </div>
    </section>
  );
};

export default WhyUs;
